import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IconEye } from '@tabler/icons-react';
import DocPreviewPanel from '../../../components/user/DocPreviewPanel';
import templateSetService from '../../../services/templateSetService';

export default function DocPrintPreviewPage() {
    const { templateSetId, docId } = useParams();
    const [loading, setLoading]       = useState(true);
    const [error, setError]           = useState(null);
    const [doc, setDoc]               = useState(null);
    const [placeholders, setPlaceholders] = useState({});

    useEffect(() => {
        const load = async () => {
            setLoading(true); setError(null);
            try {
                const setRes = await templateSetService.getTemplateSetById(templateSetId);
                const freshSet = setRes.data;

                let foundDoc = (freshSet.docs || []).find(d => String(d.id) === String(docId));
                if (!foundDoc) {
                    const docRes = await templateSetService.getTemplateDocById(docId);
                    foundDoc = docRes?.data || null;
                }
                if (!foundDoc) { setError('Document not found'); return; }

                setDoc(foundDoc);
                setPlaceholders(Object.fromEntries((freshSet.placeholders || []).map(p => [p.slug, p])));
            } catch (err) {
                setError(err.message || 'Failed to load document');
            } finally { setLoading(false); }
        };
        if (templateSetId && docId) load();
    }, [templateSetId, docId]);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen gap-2">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
                <span className="text-sm text-gray-500">Loading preview...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-screen gap-3">
                <p className="text-red-500">{error}</p>
                <button type="button" onClick={() => window.close()} className="text-sm text-gray-600 hover:underline">
                    Close Tab
                </button>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
            {/* Header bar */}
            <div
                className="flex items-center justify-between px-4 py-1.5 bg-white flex-shrink-0"
                style={{ borderBottom: '2px solid #FF9900', boxShadow: '0 2px 6px rgba(255,153,0,0.1)' }}
            >
                <div className="flex items-center gap-2">
                    <img src="/images/logo.svg" alt="Sohozkaj" style={{ height: 22, width: 'auto', display: 'block', marginRight: 4 }} />
                    <IconEye size={15} className="text-gray-400" />
                    <span className="text-sm font-semibold">{doc?.title}</span>
                    <span className="px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-500 font-medium">
                        Print Preview · Dummy data
                    </span>
                </div>
                <button
                    type="button"
                    onClick={() => window.close()}
                    className="px-3 py-1.5 text-xs text-gray-500 hover:bg-gray-100 rounded transition-colors"
                >
                    Close Tab
                </button>
            </div>

            {/* Preview content */}
            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                <DocPreviewPanel
                    templateDoc={doc}
                    formValues={doc?.previewValues || {}}
                    placeholders={placeholders}
                    hideToolbar
                />
            </div>
        </div>
    );
}
